import React, {useEffect, useState} from 'react';
import DisposeTableItem from "../../../base/dispose-tab-item";


interface IComponentProps {
  data?: any;
}
const CarTypeItem: React.FC<IComponentProps> = (props) => {
  const data = props.data;
  const [ dataList, setDataList ] = useState<any[]>([])

  useEffect(() => {
    const { price_detail  } = data
    const list = []
    if (Number(price_detail?.weekday?.price) > 0) {
      list.push(
          {
            text: `周中价格: ${price_detail?.weekday?.price / 100}元`,
          }
      )
    }
    if (Number(price_detail?.weekend?.price) > 0) {
      list.push(
          {
            text: `周末价格: ${price_detail?.weekend?.price / 100}元`
          }
      )
    }
    setDataList(list)
  }, [data]);

  return (
    <>
      <DisposeTableItem dataList={dataList}></DisposeTableItem>
    </>
  );
};

export default CarTypeItem;
